export const deClientPortalErrorHandlersErrors = {
    forbidden: {
        headline: 'Fehlende Berechtigung',
        detail: 'Falls der Fehler weiterhin auftritt, kontaktieren Sie bitte unseren Support unter support@einwert.com.',
    },
    unauthorized: {
        headline: 'Anmeldung erforderlich',
        detail: 'Bitte melden Sie sich erneut an. Falls das Problem weiterhin besteht, kontaktieren Sie bitte unseren Support unter support@einwert.com.',
    },
    missingToken: {
        headline: 'Anmeldung erforderlich',
        detail: 'Login ist abgelaufen. Bitte melden Sie sich erneut an.',
    },
    externalParticipantEmailBelongsToManagedUser: {
        headline: 'Diese Person kann nicht als externe/r Gutachter/in hinzugefügt werden',
        detail: 'Diese E-Mail-Adresse gehört bereits zu einem einwert-Konto. Bitte kontaktieren Sie unseren Support unter support@einwert.com.',
    },
    frontend: {
        headline: 'Etwas hat nicht funktioniert.',
    },
    unexpected: {
        headline: 'Ein unerwarteter Fehler ist aufgetreten.',
    },
}
